<template>
    <div ref="salesAnalysisBarLineChart" style="min-height: 400px;" v-if="data != null"></div>
    <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
        <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    export default {
        data () {
            return {

            }
        },
        mounted () {
            this.createChart();
            this.getData();
        },
        props : ['data'],
        watch : {
            data : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                let length = this.chart.data.length;

                let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                let data = [];
                if (this.data != null && this.data.length > 0) {
                    data = this.data.map((x)=>{return{
                        month : monthNames[x.month-1],
                        sales : x.sales
                    }})
                } else {
                    data = [{
                        "month" : "No Data",
                        "sales" : 0
                    }]
                }

                this.chart.addData(data, length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.salesAnalysisBarLineChart, am4charts.XYChart);

                // Export
                // chart.exporting.menu = new am4core.ExportMenu();

                // Data for both series
                // let data = [{
                //     "month": "January",
                //     "sales": 235,
                //     "target": 211
                // }, {
                //     "month": "February",
                //     "sales": 262,
                //     "target": 305
                // }, {
                //     "month": "March",
                //     "sales": 301,
                //     "target": 349
                // }, {
                //     "month": "April",
                //     "sales": 295,
                //     "target": 311
                // }, {
                //     "month": "May",
                //     "sales": 306,
                //     "target": 282,
                // }, {
                //     "month": "June",
                //     "sales": 306,
                //     "target": 282,
                // }];

                /* Create axes */
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "month";
                categoryAxis.renderer.minGridDistance = 30;
                categoryAxis.title.text = 'Month';

                /* Create value axis */
                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.title.text="No. of Sales / Sales Target";

                /* Create series */
                let columnSeries = this.chart.series.push(new am4charts.ColumnSeries());
                columnSeries.name = "No. of Sales";
                columnSeries.dataFields.valueY = "sales";
                columnSeries.dataFields.categoryX = "month";

                columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
                columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
                columnSeries.columns.template.propertyFields.stroke = "stroke";
                columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
                columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
                columnSeries.tooltip.label.textAlign = "middle";

                // let lineSeries = chart.series.push(new am4charts.LineSeries());
                // lineSeries.name = "Sales Target";
                // lineSeries.dataFields.valueY = "target";
                // lineSeries.dataFields.categoryX = "month";

                // lineSeries.stroke = am4core.color("#fdd400");
                // lineSeries.strokeWidth = 3;
                // lineSeries.propertyFields.strokeDasharray = "lineDash";
                // lineSeries.tooltip.label.textAlign = "middle";

                // let bullet = lineSeries.bullets.push(new am4charts.Bullet());
                // bullet.fill = am4core.color("#fdd400"); // tooltips grab fill from parent by default
                // bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
                // let circle = bullet.createChild(am4core.Circle);
                // circle.radius = 4;
                // circle.fill = am4core.color("#fff");
                // circle.strokeWidth = 3;

                // Add a legend
                this.chart.legend = new am4charts.Legend();

                // Add cursor
                this.chart.cursor = new am4charts.XYCursor();

                // chart.data = data;
            }
        }
    }
</script>

<style scoped>

</style>